<template>
    <oss-dialog
        v-model="isVisible"
        :hide-valid="true"
        :title="dialogTitle"
    >
        <v-row class="pa-5 ma-0" data-cy="AuditCheckDocumentDialog_Row">
            <v-col v-for="auditCheck in auditChecks" :key="auditCheck.check">
                <AuditCheckCard
                    v-if="auditCheck.count > 0"
                    @auditCheckCardClicked="onAuditCheckCardClicked"
                    :auditCheckItemsCount="auditCheck.count"
                    :auditCheckName="auditCheck.check"
                    :shouldRedirectOnClick="true"
                    :hasDarkBorder="true"
                    :data-cy="'AuditCheckDocumentDialog_' + auditCheck.check + '_Card'"
                >
                </AuditCheckCard>
            </v-col>
        </v-row>
    </oss-dialog>
</template>

<script lang="ts">
import { Component, Model, toNative, Prop, Vue } from "vue-facing-decorator";

import { AuditCheckDocumentResult } from "@/types/auditCheck.types";
import { AuditCheckDocumentName } from "@/views/document/enum/AuditCheckDocumentName.enum";

import AuditCheckCard from "@/views/audit/AuditCheckCard.vue";

@Component({
    components: {
        AuditCheckCard,
    },
})
export class AuditCheckDocumentDialog extends Vue {
    /**
     * Indicates if the dialog is visible or not.
     */
    @Model() isVisible: boolean;

    /**
     * Company id. Mandatory prop.
     */
    @Prop({ type: String, required: true }) readonly companyId!: string;

    /**
     * Audit checks. Mandatory prop.
     */
    @Prop({ required: true }) readonly auditChecks!: AuditCheckDocumentResult[];

    /**
     * Returns the AuditCheckDocumentName enum so it can be used in the template.
     */
    get AuditCheckDocumentName(): typeof AuditCheckDocumentName {
        return AuditCheckDocumentName;
    }

    /**
     * Dialog title
     */
    get dialogTitle(): string {
        return this.$t("audit.CheckDocumentAnomaly.countMessage", {
            count: this.auditCheckDocumentTotalCount,
        });
    }

    /**
     * Total count of audit check documents
     */
    get auditCheckDocumentTotalCount(): number {
        return this.auditChecks.reduce((acc, checkDocument) => acc + checkDocument.count, 0);
    }

    /**
     * When an audit check card is clicked, we hide the dialog.
     */
    onAuditCheckCardClicked(): void {
        this.isVisible = false;
    }
}

export default toNative(AuditCheckDocumentDialog);
</script>
